const $$splitComponentImporter = () => import('/src/src/routes/enrollment/profile.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/enrollment/profile")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    referrer: z.string().optional(),
    invitationId: z.uuid().optional(),
    openInvitationId: z.uuid().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Profile",
      description: "Page title for the enrollment profile page"
    })
  }
});